/*
  Вкладка «Приказ»: что стало с делом после суда — §3.6, §3.4.5.

  Отделена от вкладки «Суд» 21.09.2026 по указанию владельца. Подача и
  полученный приказ - разные заходы, между ними проходят недели: заявление
  подают и забывают о счёте, а возвращаются к нему, когда из суда что-то
  пришло. Держать эти формы вместе значит показывать человеку, собирающему
  пакет, поля для номера дела, которого ещё нет.

  Два блока и порядок между ними: сначала приказ заводят, потом - если должник
  возразил - отмечают отмену. Блок отмены показывается сам, по стадии счёта:
  на счёте, где приказа нет, отменять нечего.

  🔴 Вкладка показывается только при праве вести дело (`manage_stages`), как и
  «Суд»: заведение приказа - процессуальное действие.
*/

import EnforcementForm from './EnforcementForm.jsx'
import LawsuitPanel from './LawsuitPanel.jsx'
import OrderCancellation from './OrderCancellation.jsx'

export default function AccountOrderTab({ card, sections, sectionsError, assemble, onDone }) {
  return (
    <>
      {/* Карточка перечитывается и после заведения приказа (06.10.2026): приказ
          переводит поданный счёт в «приказ получен», и стадия, дорога и «Дела по
          счёту» должны показать это сразу. */}
      <EnforcementForm
        accountId={card.account_id}
        sections={sections}
        sectionsError={sectionsError}
        onDone={onDone}
      />

      {/* Карточка перечитывается: отмена меняет стадию, ленту движения дела и
          состав документов сразу. */}
      <OrderCancellation
        accountId={card.account_id}
        stage={card.stage}
        districtCourt={card.district_court}
        onDone={onDone}
      />

      {/* Иск - после отмены приказа или сразу, когда долг дороже предела
          приказного производства (07.10.2026, вариант А). */}
      <LawsuitPanel
        card={card}
        sections={sections}
        sectionsError={sectionsError}
        assemble={assemble}
        onDone={onDone}
      />
    </>
  )
}
